import { useSEO, SITE_URL } from "@/hooks/useSEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import CategoryGrid from "./components/CategoryGrid";
import AllCategoriesSection from "./components/AllCategoriesSection";
import ArticlesSection from "./components/ArticlesSection";
import TestimonialSection from "./components/TestimonialSection";
import CTASection from "./components/CTASection";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "kakobuy.one",
  url: SITE_URL,
  description: "Kakobuy Spreadsheet Polska: kompleksowe przewodniki zakupowe, listy produktów, porównania agentów i porady dotyczące bezpiecznych zakupów. Odkryj najlepszy kakobuy spreadsheet dla polskich użytkowników.",
  inLanguage: "pl-PL",
  publisher: {
    "@type": "Organization",
    name: "kakobuy.one",
    url: SITE_URL,
  },
};

const orgJsonLd = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "kakobuy.one",
  url: SITE_URL,
  description: "Platforma informacyjna Kakobuy Spreadsheet — przewodniki zakupowe, listy produktów i porady dla polskich kupujących.",
  sameAs: ["https://kaspreadsheet.com/"],
};

export default function Home() {
  useSEO({
    title: "Kakobuy Spreadsheet Polska – Przewodniki, Listy Produktów i Zakupy",
    description: "Kakobuy Spreadsheet Polska: kompleksowe przewodniki zakupowe, listy produktów, porównania agentów i porady dotyczące bezpiecznych zakupów. Odkryj najlepszy kakobuy spreadsheet dla polskich użytkowników.",
    keywords: "kakobuy spreadsheet, kakobuy lista produktów, kakobuy Polska, kakobuy przewodnik, zakupy Kakobuy, kakobuy agent zakupowy",
    canonicalPath: "/",
    ogTitle: "Kakobuy Spreadsheet Polska – Przewodniki, Listy Produktów i Zakupy",
    ogDescription: "Kompleksowe przewodniki zakupowe Kakobuy Spreadsheet. Listy produktów, porównania agentów i bezpieczne zakupy z Chin do Polski.",
    ogType: "website",
    ogLocale: "pl_PL",
    jsonLd: [homeJsonLd, orgJsonLd],
  });

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <AboutSection />
        <CategoryGrid />
        <AllCategoriesSection />
        <ArticlesSection />
        <TestimonialSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}